import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkChangeExemption } from '../types';

const onArchiveExemption: IThunkChangeExemption = thunk(async (_, { exemptionId, ...client }) => {
  await api.communityEngagement.archiveExemption(client, exemptionId);
});

export default onArchiveExemption;
